import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, HostListener, inject, input, OnInit, output, signal, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { EnpsComponent } from '@src/suite/common/components/base/enps-component';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { CardViewType } from '@src/suite/common/enums/enums';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { selectIsTemplates, selectIsWastebin } from '@src/suite/common/store/navigation/selectors/navigation.selectors';
import { getRundownSecurityPrivsWrite } from '@src/suite/common/utils/record-utils';
import { LiveApiActions } from '@src/suite/live/store/actions/live.actions';
import { DateTime } from 'luxon';

import { CardLeftBorderDirective } from '../../../common/directives/card-left-border';
import { ClickStopPropagationDirective } from '../../../common/directives/stop-propagation';

@Component({
    selector: 'st-live-card-item',
    imports: [CardLeftBorderDirective, ClickStopPropagationDirective, MatIcon, MatIconButton, MatTooltip, NgTemplateOutlet],
    templateUrl: './st-live-card-item.component.html',
    styleUrl: './st-live-card-item.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-live-card-item',
    },
})
export class StLiveCardItemComponent extends EnpsComponent implements OnInit {
    store = inject(Store);
    globalTablesService = inject(GlobalTablesService);

    languageSettings = this.store.selectSignal(selectI18N);
    isWastebin = this.store.selectSignal(selectIsWastebin);
    isTemplates = this.store.selectSignal(selectIsTemplates);

    readonly rundownOpenEmitter = output<void>();
    readonly restoreContent = output();
    readonly isLast = input<boolean>();
    readonly data = input<StorytellingRundownRecord>();
    readonly cardViewType = input(CardViewType.LARGE);

    readonly inView = signal(false);

    // public rundownCliked = output<void>();

    pstFieldNames = PSTFieldNames;
    CardViewTypes = CardViewType;

    ngOnInit() {
        setTimeout(() => {
            this.inView.set(true);
        }, 0);
    }

    @HostListener('click')
    public onClick() {
        this.rundownOpenEmitter.emit();
    }

    readonly startTime = computed(() => {
        return this.data()?.StartTime?.toLocaleString(DateTime.TIME_SIMPLE);
    });

    readonly startDate = computed(() => {
        return this.data()?.StartTime?.toLocaleString(DateTime.DATE_SHORT);
    });

    readonly endTime = computed(() => {
        return this.data()?.EndTime?.toLocaleString(DateTime.TIME_SIMPLE);
    });

    readonly endDate = computed(() => {
        return this.data()?.EndTime?.toLocaleString(DateTime.DATE_SHORT);
    });

    readonly archivedLabel = computed(() => {
        return this.languageSettings()?.PSTRundownArchived;
    });

    readonly isArchived = computed(() => {
        return this.data()?.Path?.isArchivePath || this.data()?.isArchived;
    });

    readonly rundownEditable = computed(() => {
        return getRundownSecurityPrivsWrite({ rec: this.data(), globalTablesService: this.globalTablesService }) && !this.data()?.Path?.isWasteBinPath && !this.data()?.Path?.isArchivePath;
    });

    readonly displayOpenActionButtonHoverTitle = computed(() => {
        return this.globalTablesService.getDisplayOpenActionButtonHoverTitle(false)();
    });

    onAir() {
        this.store.dispatch(LiveApiActions.onAir({ guid: this.data().Guid }));
    }

    mosControlActive() {
        this.store.dispatch(LiveApiActions.mosControlActive({ guid: this.data().Guid }));
    }

    mosReadyToAir() {
        this.store.dispatch(LiveApiActions.mosReadyToAir({ guid: this.data().Guid }));
    }
}
